'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InteractionTag", {
    enumerable: true,
    get: function() {
        return InteractionTag;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useInteractionTag = require("./useInteractionTag");
const _renderInteractionTag = require("./renderInteractionTag");
const _useInteractionTagStylesstyles = require("./useInteractionTagStyles.styles");
const _useInteractionTagContextValues = require("./useInteractionTagContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const InteractionTag = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useInteractionTag.useInteractionTag_unstable)(props, ref);
    (0, _useInteractionTagStylesstyles.useInteractionTagStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useInteractionTagStyles_unstable')(state);
    return (0, _renderInteractionTag.renderInteractionTag_unstable)(state, (0, _useInteractionTagContextValues.useInteractionTagContextValues_unstable)(state));
});
InteractionTag.displayName = 'InteractionTag';
